<template>
  <div class="article">
    <p class="article-title">
      {{ $t('2025.08.28–2025.09.05 “把爱传下去”第二期项目进展') }}
    </p>
    <p class="article-time">2025/10/27</p>
    <div class="article-body">

      <p class="article-para">
        {{ $t('在CBiBank公益项目“把爱传下去”和其他公益人士的努力下，贫困地区孩子们的教育受到了越来越多的关注，更多爱心得以输送到孩子们身边。“把爱传下去”第一期捐助圆满收官后，我们继续积极联系一个村小，寻找第二期的捐助对象，并于2025年8月迎来10位新同学。') }}
      </p>
      <div class="article-img-max-1000">
        <img
          src="@/assets/image/news-detail/20251027/img-1.png"
          alt=""
        />
      </div>

      <p class="article-para">
        {{ $t('“把爱传下去”第二期捐助的10名女孩儿都来自四川凉山，2名为初中生，8名为高中生。她们之中，有三位同学家住偏远山区，父母年事渐高，收入渠道有限，且家里子女众多，沉重的经济压力让作为女孩儿的她们求学之路越发艰难；有五位同学父亲早逝，由母亲独自一人抚养多个孩子，收入微薄，如果没有经济上的帮助和爱心的鼓励，她们随时都有可能放弃学业；还有两位同学的父母常年被病痛困扰，劳动能力弱，医疗和教育这两大家庭主要支出的博弈，使她们的前路充满未知。') }}
      </p>
      <p class="article-para">
        {{ $t('纵然艰难，但这些女孩儿们对未来都充满着期待。她们有的现在就读职业学校，希望有机会考入大专、升入本科，找到更好的工作；有的励志成为老师、医生、法医，为社会做出自己的贡献；有的已经有心仪的大学作为努力的目标，希望将来有能力报答自己的父母。') }}
      </p>
      <p class="article-para">
        {{ $t('为守护她们这份坚韧而朴实的爱，以及对知识和未来的渴望，“把爱传下去”第二期第一笔捐款，人民币13000元，已于2025年9月5日汇出至各位同学的银行账户，用以减轻她们2025-2026学年第一学期的经济压力；8名来自CBiBank的志愿者已经就位，各位志愿者利用工作之余的时间，为孩子们提供关怀、支持和心理纾解。') }}
      </p>
      <p class="article-para">
        {{ $t('“把爱传下去”继续小而精地帮助暂时被贫困扼住脚步的她们，用爱陪伴，让她们有机会追逐更多更大的可能。期待未来求学的日子里，女孩们可以更勇敢、坚定地追逐梦想！') }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  methods: {
  }
}
</script>

<style scoped lang="less">
</style>
